import * as React from "react";
import * as ReactDOM from "react-dom";

type ChildrenFunc = (data: any, index: number) => JSX.Element;

interface IProperties
{
    /**
     * Inline-Style
     */
    style?: React.CSSProperties,

    /**
     * Enthält die ListViewItems oder ein Funktion die von der ListView
     * aufgerufen wird und als Rückgabewert ein Item erhält.
     */
    children?: ChildrenFunc | JSX.Element | JSX.Element[],

    /**
     * Ein Objekt mit den gebundenen Daten.
     */
    dataSource?: any[]
}

export class ListView extends React.Component<IProperties>
{
    /**
     * Wenn eine DataSource übergeben wurde, werden hier die Items
     * anhand der DataSource ermittelt.
     */
    private getItems()
    {
        var { children, dataSource } = this.props;
        var items: any[] = [];
        var func: ChildrenFunc = children as ChildrenFunc;

        for (var i = 0; i < dataSource.length; i++)
        {
            items.push(func(dataSource[i], i))
        }

        return items;
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        return (
            <div
                style={this.props.style}
                className="listview">
                {this.props.dataSource ? this.getItems() : this.props.children}
            </div>
        );
    }
}